import React from 'react';

import { useTheme } from '@mui/material';
import { styled } from '@mui/material';

import ClockSmallIcon from '~/assets/icons/ClockSmallIcon';
import { BodyText } from '~/components/UI/Texts';
import { SMALL_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';
import { formatDuration } from '~/utils/dateUtils/formatDuration';

const Duration = ({ duration, ...rest }) => {
  const theme = useTheme();

  return (
    <Label color={theme.palette.common.text.duration} {...rest}>
      <ClockSmallIcon />
      <BodyText data-testid="videPlayerDuration">{formatDuration(duration)}</BodyText>
    </Label>
  );
};

export default Duration;

export const Label = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})`
  display: flex;
  align-items: center;
  margin-right: ${SMALL_MARGIN_PX};
  margin-bottom: ${TINY_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-bottom: 0;
  }

  & svg {
    width: 24px;
    height: 24px;
    margin-right: ${TINY_MARGIN_PX};
    color: ${({ color }) => color};
  }

  & p {
    color: ${({ color }) => color};
    margin-bottom: 2px;
  }
`;
